import { FullContainer } from '@gorila-shared-ui/components';
import { useStyles } from '../../../hooks/useStyles';
import FleetDriverList from '../../fleet/drivers/FleetDriverList';
import FleetDriversFiltersBar from '../../fleet/drivers/FleetDriversFiltersBar';

function FleetDriversPage() {
  const { classes } = useStyles();

  return (
    <FullContainer
      verticalFlex
      classNames={classes.basicPageContainer}
    >
      <FleetDriversFiltersBar />
      <FleetDriverList />
    </FullContainer>
  );
}

export default FleetDriversPage;
